import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models/finnair-itinerary-item-flight';
import { LocationInfoMap } from '@fcom/dapi/interfaces/itinerary.interface';
import { NotificationLayout, NotificationTheme } from '@fcom/ui-components/components/notifications/enums';

import { BUS_AIRCRAFT_CODE } from '../../../interfaces/utils.interface';
import { EndPointChanges } from '../../../interfaces/endpoint-changes.interface';
import { getBoundArrivalNotification } from '../bound-arrival-notification.utils';

@Component({
  selector: 'fin-itinerary-timeline-leg-technical-stops',
  styleUrls: ['../itinerary.scss', '../arrow-block.scss'],
  templateUrl: './leg-technical-stops.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItineraryTimelineLegTechnicalStopsComponent {
  readonly BUS_AIRCRAFT_CODE = BUS_AIRCRAFT_CODE;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly NotificationTheme = NotificationTheme;
  readonly NotificationLayout = NotificationLayout;

  @Input()
  leg: FinnairItineraryItemFlight;

  @Input()
  locations: LocationInfoMap;

  @Input()
  firstLeg = false;

  @Input()
  lastLeg = false;

  @Input()
  oldArrivalDateTime: string;

  @Input()
  oldArrivalLocationCode: string;

  @Input()
  arrivalChanges: EndPointChanges;

  @Input()
  isCanceled: boolean;

  get arrivalNotification(): string | undefined {
    return getBoundArrivalNotification(this.lastLeg, this.arrivalChanges, this.isCanceled);
  }
}
